import React from 'react';
import { useDomainVerification } from '../../context';

export const Error = (props) => {
  const { retriesLeft = false, notOwner = false } = props;
  const { back } = useDomainVerification();

  return (
    <div className="verification verification-failed">
      <div className="verification-failed error-message">
        <h1>Verification Failed</h1>
        { notOwner
          ? (
            <p>
              Only the site owner can verify your site&apos;s domain. Please ask them about domain verification.
            </p>
          ) : (
            <p>
              If the domain verification process failed, make sure you have sent the verification using our
              {' '}
              <a href="https://www.realgeeks.com/support/">support form</a>
              {' '}
              and received confirmation that your TXT record has been initialized
            </p>
          )
        }
      </div>
      <div className="verification-failed contact-support">
        {
          retriesLeft
            ? <button type="button" className="retry" onClick={back}>Try again</button>
            : <a href="https://www.realgeeks.com/support/">Contact Real Geeks Support</a>
        }
      </div>
    </div>
  );
};
